import React, { useState, useEffect } from 'react';
import { FiPhoneOff, FiMic, FiMicOff, FiVolume2, FiUser } from 'react-icons/fi';

const ActiveCall = ({ number, status, duration, onEnd, isMuted, toggleMute }) => {
    return (
        <div className="card animate-fade glass-card" style={{ maxWidth: '400px', margin: '2rem auto', textAlign: 'center', padding: '3rem 2rem' }}>
            <div style={{ marginBottom: '2rem' }}>
                <div style={{
                    width: '100px', height: '100px', background: 'var(--primary)',
                    borderRadius: '50%', margin: '0 auto', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 0 30px rgba(99, 102, 241, 0.4)',
                    position: 'relative'
                }}>
                    <FiUser size={48} color="white" />
                    <div className="pulse" style={{
                        position: 'absolute', width: '100%', height: '100%',
                        borderRadius: '50%', border: '2px solid var(--primary)',
                        animation: 'pulse-ring 2s infinite'
                    }}></div>
                </div>
            </div>

            <h2 style={{ marginBottom: '0.5rem' }}>{number}</h2>
            <p style={{ color: status === 'connected' ? 'var(--success)' : 'var(--text-muted)', fontWeight: 600, fontSize: '0.875rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                {status} • {duration}
            </p>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', margin: '3rem 0' }}>
                <button
                    onClick={toggleMute}
                    style={{
                        width: '60px', height: '60px', borderRadius: '50%', border: '1px solid var(--border)',
                        background: isMuted ? 'var(--danger)' : 'rgba(255,255,255,0.05)',
                        color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                    }}
                >
                    {isMuted ? <FiMicOff size={24} /> : <FiMic size={24} />}
                </button>

                <button
                    style={{
                        width: '60px', height: '60px', borderRadius: '50%', border: '1px solid var(--border)',
                        background: 'rgba(255,255,255,0.05)',
                        color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}
                >
                    <FiVolume2 size={24} />
                </button>
            </div>

            <button
                onClick={onEnd}
                className="call-btn"
                style={{
                    background: 'var(--danger)',
                    marginTop: '0',
                    width: '100%',
                    height: '4.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.75rem',
                    fontSize: '1.125rem',
                    fontWeight: '600',
                    padding: '1.25rem 2rem',
                    borderRadius: '1rem'
                }}
            >
                <FiPhoneOff size={28} /> End Call
            </button>

            <style>{`
        @keyframes pulse-ring {
          0% { transform: scale(0.8); opacity: 0.5; }
          100% { transform: scale(1.5); opacity: 0; }
        }
      `}</style>
        </div>
    );
};

export default ActiveCall;
